import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';
import { TrapType } from 'components/AnalyticsPage/TrapType';

export interface PieActivationsChartData {
  L: number[];
  R: number[];
  labels: string[];
}

export const getTrapDetailPieActivationsChartData = async (slug: string, trapType: TrapType) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const data = await axiosInterceptor.get(`api/v1/traps/charts/pie_chart_by_activations/${slug}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      type: trapType,
    },
  });

  return data.data as PieActivationsChartData;
};
